import { render, staticRenderFns } from "./delete-account-form.vue?vue&type=template&id=3af5c55a&lang=pug&"
import script from "./delete-account-form.vue?vue&type=script&lang=js&"
export * from "./delete-account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports